import { LinkService } from 'src/app/services/general/link.service';
import { NewsCardTncComponent } from 'src/app/components/news-card/news-card-tnc/news-card-tnc.component';
import { LocalityService } from 'src/app/services/location/locality.service';
import { ModalController, PopoverController, Platform } from '@ionic/angular';
import { AccountTaskService } from 'src/app/services/account/account-task.service';
import { AccountTaskType } from 'src/app/types/task';
import { VoucherService } from 'src/app/services/subscription/voucher.service';
import { NavigationExtras, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NewsType } from 'src/app/types/news';

import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { LocationComponent } from 'src/app/components/general/location/location.component';
import { AccountCoupleComponent } from 'src/app/components/account/account-couple/account-couple.component';
import { LanguageService } from 'src/app/services/general/language.service';

import { BlastRedeemService } from 'src/app/services/blast/blast-redeem.service';
import { BlastCreditRedeemComponent } from 'src/app/components/blast/credit/blast-credit-redeem/blast-credit-redeem.component';
import { PopupService } from 'src/app/services/general/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { Voucher } from 'src/app/interfaces/voucher';

import { SettingVisitorComponent } from '../../setting/setting-visitor/setting-visitor.component';
import { VisitorSettingType } from 'src/app/types/visitor';
import { SeatingSettingService } from 'src/app/services/seating/seating-setting.service';
// import { SettingVisitorWizardComponent } from '../../setting/setting-visitor-wizard/setting-visitor-wizard.component';
import { DateTimeService } from 'src/app/services/general/date-time.service';
import { Subscription } from 'rxjs';
import { VisitorModeService } from 'src/app/services/visitor/visitor-mode.service';
// import { BlastNoticeComponent } from '../../blast/blast-notice/blast-notice.component';

@Component({
  selector: 'app-news-card-item',
  templateUrl: './news-card-item.component.html',
  styleUrls: ['./news-card-item.component.scss'],
})
export class NewsCardItemComponent implements OnInit, OnDestroy {
  
  @Input() title: string;
  
  @Input() type: NewsType;

  @Input() accountTaskType: AccountTaskType;

  @Input() showActionBtn: boolean;

  @Output() clickAction = new EventEmitter<any>();

  iosApp: boolean;

  specialPromoVoucher: string;

  seatingTypeName: string;

  language: string;

  defaultVoucher: string;

  accountCountry: string;

  private tncPopover: HTMLIonPopoverElement;

  private languageSubscription: Subscription;

  private accountInfoSubscription: Subscription;

  constructor(
    private platform: Platform,
    private router: Router,
    private translate: TranslateService,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private localityService: LocalityService,
    private languageService: LanguageService,
    private accountInfoService: AccountInfoService,
    private accountTaskService: AccountTaskService,
    private visitorModeService: VisitorModeService,
    private seatingSettingService: SeatingSettingService,
    private blastRedeemService: BlastRedeemService,
    private voucherService: VoucherService,
    private dateTimeService: DateTimeService,
    private linkService: LinkService,
    private popupService: PopupService,
  ) { }

  async ngOnInit() {
    await this.platform.ready();
    if (this.platform.is('hybrid') && this.platform.is('ios')) {
      this.iosApp = true;
    } else {
      this.iosApp = false;
    }

    if (this.accountTaskType === 'assign_seating') {
      this.seatingTypeName = this.getSeatingTypeName();
    }
    this.specialPromoVoucher = this.getSpecialPromo(3);
    this.defaultVoucher = this.getDefaultVoucher();
    this.accountCountry = this.getAccountCountry();

    this.watchUserLanguage();
    this.watchAccountInfo();
  }

  getLanguage(): string {
    const language = this.languageService.getUserLanguage()?.code?.toLowerCase();
    if (this.type === 'trial_suggestion' || this.type === 'why_premium' || this.type === 'help_center' || this.type === 'whatsapp_launching' || this.type === 'guest_web_launching') {
      if (language === 'zh') {
        return 'zh-tw';
      }
    }
    return language && language !== 'ms' ? language : 'en';
  }

  getAccountCountry(): string {
    let country = this.localityService.getAccountCountry()?.code;
    return country;
  }

  getAccountId() {
    return this.accountInfoService.accountId ? true : false;
  }

  getNewWebsiteMode() {
    return this.visitorModeService.checkNewWebsite();
  }

  ngOnDestroy() {
    this.unwatchUserLanguage();
    this.unwatchAccountInfo();
  }

  watchUserLanguage() {
    if (!this.languageSubscription) {
      this.languageSubscription = this.languageService.observableUserLanguage.subscribe(() => {
        this.language = this.getLanguage();
      });
    }
  }

  unwatchUserLanguage() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
      this.languageSubscription = null;
    }
  }

  watchAccountInfo() {
    if (!this.accountInfoSubscription) {
      this.accountInfoSubscription = this.accountInfoService.observableAccountInfo.subscribe(() => {
        this.accountCountry = this.getAccountCountry();
      })
    }
  }

  unwatchAccountInfo() {
    if (this.accountInfoSubscription) {
      this.accountInfoSubscription.unsubscribe();
      this.accountInfoSubscription = null;
    }
  }

  cardAction() {
    if (this.type === 'special_promo_voucher') {
      if (this.getSpecialPromo()) {
        this.goSubscriptionPage();
      } else {
        const voucher: Voucher = this.getSpecialVoucherById(this.getSpecialPromo(3));
        if (voucher?.startDate) {
          this.popupService.presentAlert(this.translate.instant('VOUCHER.validation.start_date', { date: this.dateTimeService.format(new Date(voucher.startDate + 'T00:00:00'), 'do MMM yyyy') }));
        }
      }
    } else if (this.type === 'blast_redeem' && this.blastRedeemService.validateRedeemBlastCredit()) {
      this.presentSmCreditRedeemModal();
    } else if (this.type === 'blast_intro') {
      this.goBlastHomePage();
    } else if (this.type === 'theme') {
      this.presentVisitorSetting('theme');
    } else if (this.type === 'chrome') {
      this.linkService.openUrl('https://www.google.com/chrome');
    } else if (this.type === 'account_gift') {
      const navigationExtras: NavigationExtras = {
        state: { giftMode: true }
      };
      if (this.platform.is('ios') && this.platform.is('hybrid')) {
        this.router.navigate([ '/subscription/premium' ], navigationExtras);
      } else {
        this.router.navigate(['/subscription/account']);
      }
    } else if (this.type === 'help_center') {
      this.linkService.goHelpCenter();
    } else if (this.type === 'platform') {
      this.linkService.goAppDownloadPage(true);
    } else if (this.type === 'referral') {
      this.router.navigate(['/user/referral']);
    } else if (this.type === 'trial_upgrade') {
      const navigationExtras: NavigationExtras = {
        state: { upgradeTrial: true }
      };
      if (this.platform.is('hybrid') && this.platform.is('ios')) {
        this.router.navigate([ '/subscription/premium' ], navigationExtras);
      } else {
        this.router.navigate(['/subscription/account'], navigationExtras);
      }
    } else if (this.type === 'setup_venue') {
      this.presentLocationModal();
    } else if (this.type === 'invite_couple') {
      this.presentCoupleModal();
    } else if (this.type === 'migrate_gift') {
      this.router.navigate(['/user/credit']);
    } else if (this.type === 'account_compare') {
      const navigationExtras: NavigationExtras = {
        state: { }
      };
      this.router.navigate(['/subscription/account-comparison'], navigationExtras);
    } else if (this.type === 'why_premium') {
      const navigationExtras: NavigationExtras = {
        state: { }
      };
      this.router.navigate([ '/subscription/premium' ], navigationExtras);
    } else if (this.accountTaskType) {
      this.accountTaskService.goChecklistAction(this.accountTaskType);
    } else if (this.type === 'blast_notice') {
      this.goBlastNoticePage();
    } else if (this.type === 'whatsapp_launching') {
      this.goBlastLaunchingPage();
    } else if (this.type === 'web_checkin_launching') {
      if (this.accountInfoService?.accountId) {
        this.presentVisitorSetting('setting');
      }
    } else if (this.type === 'trial_suggestion') {
      this.router.navigate(['/subscription/trial']);
    } else if (this.type === 'guest_web_launching') {
      if (this.accountInfoService?.accountId) {
        this.router.navigate(['/website-setting/home']);
      } else {
        this.router.navigate(['/accounts/add']);
      }
    } else if (this.accountTaskType === 'checkin_guest') {
      this.router.navigate(['/tabs-checkin/list']);
    }
  }

  btnAction() {
    if (this.type === 'account_voucher') {
      this.goSubscriptionPage();
    } else {
      this.clickAction.next(true);
    }
  }

  getSpecialPromo(revertStartDays?: number) {
    let voucherId = this.voucherService.getSpecialPromoVoucher(new Date());
    if (!voucherId && revertStartDays) {
      voucherId = this.voucherService.getSpecialPromoVoucher(new Date(), revertStartDays);
    }
    return voucherId;
  }

  getSpecialVoucherById(voucherId: string) {
    return this.voucherService.getSpecialPromoVoucherById(voucherId);
  }

  getSmsPromo() {
    return this.voucherService.getSmsPromo();
  }

  getCurrentPromo(): string {
    return this.voucherService.getCurrentPromo();
  }

  getDefaultVoucher(): string {
    return this.voucherService.getDefaultVoucher();
  }

  getSeatingTypeName(): string {
    return this.seatingSettingService.getSeatingTypeName();
  }

  /**
   * Present Location Modal
   */
  async presentLocationModal() {
    const modal = await this.modalController.create({
      component: LocationComponent,
      cssClass: 'modal-full-screen-bk',
      componentProps: {
        country: this.localityService.getAccountCountry(),
      }
    });
    modal.present();
  }

  /**
   * Present Couple Modal
   */
  async presentCoupleModal() {
    const modal = await this.modalController.create({
      component: AccountCoupleComponent,
      componentProps: {
        coupleList: this.accountInfoService?.accountInfo?.coupleList
      }
    });
    modal.present();
  }

  async presentSmCreditRedeemModal() {
    if (this.blastRedeemService.validateRedeemBlastCredit()) {
      const modal = await this.modalController.create({
        component: BlastCreditRedeemComponent,
        componentProps: {
        }
      });
      modal.present();
    } else {
      this.blastRedeemService.promptError();
    }
  }

  async presentVisitorSetting(type: VisitorSettingType) {
    if (type) {
      const modal = await this.modalController.create({
        component: SettingVisitorComponent,
        cssClass: 'modal-full-screen-bk',
        componentProps: {
          type
        }
      });
      modal.present();
    }
  }

  // async presentBlastNoticeModal() {
  //   const modal = await this.modalController.create({
  //     component: BlastNoticeComponent,
  //     cssClass: 'modal-transparent',
  //     componentProps: {
  //     }
  //   });
  //   modal.present();
  //   modal.onWillDismiss().then(() => {
  //   });
  // }

  // async presentVisitorWizard() {
  //   const modal = await this.modalController.create({
  //     component: SettingVisitorWizardComponent,
  //     cssClass: 'modal-full-screen-bk',
  //     componentProps: {
  //     }
  //   });
  //   modal.present();
  // }

  async presentTncPopover() {
    await this.dismissPopover();
    this.tncPopover = await this.popoverController.create({
      component: NewsCardTncComponent,
      componentProps: {
        type: this.type
      }
    });
    this.tncPopover.present();
    this.tncPopover.onDidDismiss().then(() => {
      this.tncPopover = null;
    });
  }

  /**
   * Dismiss offline popover
   */
  async dismissPopover() {
    if (this.tncPopover) {
      await this.tncPopover.dismiss();
      this.tncPopover = null;
    }
  }

  goSubscriptionPage() {
    if (this.router.url?.indexOf('/subscription/account') !== -1) {
      this.clickAction.next(this.type === 'special_promo_voucher' ? this.getCurrentPromo() : this.getDefaultVoucher());
    } else {
      let upgradeTrial = false;
      let accountId = '';
      if (this.accountInfoService.accountInfo?.accountStatus?.trial && !this.accountInfoService.accountInfo?.accountStatus?.premium) {
        upgradeTrial = true;
        accountId = this.accountInfoService.accountInfo.accountId;
      }
      const navigationExtras: NavigationExtras = {
        state: {
          upgradeTrial,
          accountId,
          voucherId: this.type === 'special_promo_voucher' ? this.getCurrentPromo() : this.getDefaultVoucher(),
        }
      };
      if (this.platform.is('hybrid') && this.platform.is('ios')) {
        this.router.navigate([ '/subscription/premium' ], navigationExtras);
      } else {
        this.router.navigate(['/subscription/account'], navigationExtras);
      }
    }
  }

  goBlastHomePage() {
    this.router.navigate(['/blast/home']);
  }

  goBlastNoticePage() {
    this.router.navigate(['/blast/notice']);
  }

  goBlastLaunchingPage() {
    this.router.navigate(['/blast/launching']);
  }

}
